"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DeviceRegistrationInternal {
    constructor() {
        this.setDeviceKey = (key) => {
            if (this._device) {
                this._device.deviceKey = key;
            }
        };
        this.resetDeviceKey = () => {
            if (this._device) {
                this._device.deviceKey = undefined;
            }
        };
    }
    get device() {
        return this._device;
    }
    set device(value) {
        this._device = value;
    }
}
const DeviceRegistration = new DeviceRegistrationInternal();
exports.default = DeviceRegistration;
//# sourceMappingURL=DeviceRegistration.js.map